// apps/lynar/src/supabase.js
//
// Singleton del client Supabase per Lynar. Importato da qualunque modulo che
// ha bisogno di parlare con il backend (auth, db, storage).
//
// Esempio:
//   import { supabase } from './supabase.js';
//   const { data, error } = await supabase.from('profiles').select('*');

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  // In dev questo crasha forte e fa rumore — meglio scoprirlo al primo run
  // che debuggare un 'undefined is not a function' 20 livelli sotto.
  throw new Error(
    '[supabase] Mancano VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY. ' +
    'Copia apps/lynar/.env.local.example in apps/lynar/.env.local e riempi i valori dal dashboard Supabase.'
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // Persistenza session in localStorage. Quando arrivera' auth con magic link
    // (Sprint 1) questo permette al login di sopravvivere a refresh / restart.
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

// Esposizione anche su window per debug rapido dalla browser console.
// (Removable in prod se vuoi pulizia, ma niente di sensibile esposto.)
if (typeof window !== 'undefined') {
  window.supabase = supabase;
}
